import {FormattedNumber} from 'react-intl';

export default FormattedNumber;
